/**
 * Amazon Catalog Lookup Tool Page
 *
 * Feature-flagged: Only visible to platform admins.
 * Uses existing AmazonCatalogLookup component from integrations.
 */

import { useTranslation } from 'react-i18next'
import { useSupabaseAuth } from '@/contexts/SupabaseAuthContext'
import { AmazonCatalogLookup } from '@/components/v2/workspace-settings/integrations/amazon'
import { ShoppingCart, ShieldAlert } from 'lucide-react'
import { EmptyState } from '@/components/v2/ui'

export function AmazonCatalogPage() {
  const { t } = useTranslation()
  const { user } = useSupabaseAuth()

  if (!user?.is_admin) {
    return (
      <div className="flex items-center justify-center h-full p-8">
        <EmptyState
          icon={<ShieldAlert className="h-12 w-12" />}
          title={t('amazonCatalog.accessDenied')}
          description={t('amazonCatalog.accessDeniedDescription')}
        />
      </div>
    )
  }

  return (
    <div className="mx-auto max-w-4xl space-y-6 p-6">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-orange-500 to-amber-500">
          <ShoppingCart className="h-5 w-5 text-white" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-neutral-900 dark:text-neutral-50">
            {t('amazonCatalog.title')}
          </h2>
          <p className="text-sm text-neutral-500 dark:text-neutral-400">
            {t('amazonCatalog.description')}
          </p>
        </div>
      </div>
      <AmazonCatalogLookup />
    </div>
  )
}
